import React from 'react';
// import WebglBackground from 'react-scale/components/elements/webgl/glow-gradient';
import CTA from 'react-scale/components/elements/cta';
import cx from 'classnames';
import Image from 'next/image';

import s from './hero.module.css';

const hero = ({ title, subtitle, cta, img, mobileImg, theme }) => (
  <div>
    <div className="relative">
      <div
        className={cx(
          'container py-[72px] md:py-24',
          { 'text-black': theme === 'light' },
          { 'text-white': theme === 'dark' }
        )}
      >
        <div className="flex flex-col-reverse justify-center align-middle items-center md:flex-row md:space-x-28 xl:space-x-32">
          <div className="md:max-w-md lg:max-w-2xl flex-1">
            <h1 className="mb-12 md:font-[250] font-normal font-aeonik leading-[45px] text-center md:text-left lg:leading-[96px] text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              {title}
            </h1>
            <h2 className="mt-8 text-center md:text-left font-inter mb-16 md:text-2xl text-lg px-8 sm:px-10 md:px-0 md:font-aeonik md:leading-10 xl:pr-20">
              {subtitle}
            </h2>
            <div className={s.cta}>
              <CTA cta={cta} theme={theme} />
            </div>
          </div>
          <>
            {img && (
              <div
                className={cx('mb-0', {
                  'hidden md:block': mobileImg
                })}
              >
                <Image
                  loading="eager"
                  priority
                  src={img.src}
                  layout="intrinsic"
                  width={img.width}
                  height={img.height}
                />
              </div>
            )}
            {mobileImg && (
              <div className="mb-6 md:hidden">
                <Image
                  loading="eager"
                  priority
                  src={mobileImg.src}
                  layout="fixed"
                  width={mobileImg.width}
                  height={mobileImg.height}
                />
              </div>
            )}
          </>
        </div>
      </div>
    </div>
  </div>
);

hero.defaultProps = {
  title: 'Rapid Labels',
  subtitle:
    'Rapid Labels is a cloud-based, scalable, and secure label printing platform that enables you to print labels in seconds.',
  cta: {
    buttons: [{ text: 'Contact Our Team', href: '/sales', type: 'primary' }]
  },
  theme: 'dark'
};

export default hero;
